/**
 * Voice Agent Desk API — the agent's side of a live handoff from the AI.
 * Backend: /api/voice-desk/ (module voice_desk).
 */
import api from './api';

const base = '/voice-desk';

const voiceDeskApi = {
  // Calls waiting for an agent, and the calls this agent has taken.
  getHandoffs: () => api.get(`${base}/handoffs/`),
  // Take the call: returns the handoff plus join {url, token, room, identity}.
  accept: (id) => api.post(`${base}/handoffs/${id}/accept/`),
  // A fresh token for a call this agent already took (the page was reloaded mid-call).
  rejoin: (id) => api.post(`${base}/handoffs/${id}/rejoin/`),
  hangUp: (id) => api.post(`${base}/handoffs/${id}/end/`),
};

export default voiceDeskApi;
